import createObservable from '@kingstinct/observable';


export default createObservable(false);
